// import Card from "@material-ui/core/Card";
// import CardContent from "@material-ui/core/CardContent";
import { Hidden, Typography } from '@material-ui/core'
import Box from '@material-ui/core/Box'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
// import Image from "gatsby-image";
import { StoryblokComponent } from '@sb-konzept/gatsby-source-storyblok'
import RemarkRenderer from 'components/RemarkRenderer'
import React, { useState } from 'react'
import styled from 'styled-components'

// import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import HugIcon from '../../assets/images/hug-icon.png'
import HugBanner from '../../assets/images/hug-icon.svg'
// import { typography } from "@material-ui/system";

const BlackTrapezoid = styled.div`
  background-image: url(${HugBanner});
  background-repeat: no-repeat;
  background-position: right;
  background-size: cover;
  padding: 8px 48px 8px 18px;
`

const ItemIcon = () => (
  <BlackTrapezoid>
    <img alt="Two people hugging and celebrating icon" src={HugIcon} />
  </BlackTrapezoid>
)

const ThinText = styled.span`
  font-weight: 300;
`

const StoryblokHomeblock = (props) => {
  const { willkommenText, leader, trainers, news, siteInfo } = props
  const [expanded, setExpanded] = useState('panel1')

  // console.log("HB ", props);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }

  return (
    <Box display="flex" flex="1" flexDirection="column" height="auto">
      <Box
        align="stretch"
        display="flex"
        flexDirection="row"
        margin="1.45rem 10vw"
      >
        <Box flex="1">
          <Typography variant="h3">TWIN TAEKWONDO</Typography>
        </Box>
        {news && (
          <Hidden mdDown>
            {/* ml={3} // "NEWS" */}
            <Box flex="1" ml={5}>
              <Typography variant="h3">BERICHTE</Typography>
            </Box>
          </Hidden>
        )}
      </Box>

      {/* Content => Left and Right boxes */}
      <Box
        align="stretch"
        display="flex"
        flexDirection={{ xs: 'column', lg: 'row' }}
        margin="auto 10vw"
      >
        <Box
          display="flex"
          flex="1"
          flexDirection="column"
          justifyContent="space-between"
          mr={{ xs: 0, lg: 1.5 }}
        >
          <ExpansionPanel
            expanded={expanded === 'panel1'}
            onChange={handleChange('panel1')}
          >
            <ExpansionPanelSummary
              aria-controls="panel1bh-content"
              id="panel1bh-header"
            >
              <ItemIcon />
              <Typography variant="h4">
                HERZLICH{' '}
                <Hidden smUp>
                  <br />
                </Hidden>
                <ThinText>WILLKOMMEN</ThinText>
              </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <Box pb={3}>
                {willkommenText ? (
                  <RemarkRenderer
                    editable
                    ast={willkommenText.childMarkdownRemark?.htmlAst}
                  />
                ) : null}
                {/* {willkommenText} */}
                {/* <Typography>{welcomeText}</Typography> */}
              </Box>
            </ExpansionPanelDetails>
          </ExpansionPanel>

          <ExpansionPanel
            expanded={expanded === 'panel2'}
            style={{ margin: '24px 0' }}
            onChange={handleChange('panel2')}
          >
            <ExpansionPanelSummary
              aria-controls="panel2bh-content"
              id="panel2bh-header"
            >
              <ItemIcon />
              <Typography variant="h4">
                STANDORT
                <ThinText>
                  <Hidden smUp>
                    <br />
                  </Hidden>
                  LEITER
                </ThinText>
              </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              {leader ? <StoryblokComponent content={leader[0]} /> : null}
              {/* Code below renders nicely but exported exact code to StoryblokComponent
              above (photocard) and it doesn't sit correctly due to the gatsby images */}
              {/* <Box
                display="flex"
                alignItems="center"
                flexDirection={{ xs: "column", sm: "row" }}
                // pb={3}
              >
              <Box
                  flex="1 1 15%"
                  mr={{ xs: 0, sm: 3 }}
                  mb={{ xs: 2, sm: 0 }}
                  width={{ xs: "100%", sm: "auto" }}
                >
                  <Image
                    fluid={leaderImage.localFile.childImageSharp.fluid}
                    loading="eager"
                  />
                </Box>
                <Box flex={2.5}>
                  <Typography>
                    <b>Der Standortleiter: </b>
                    {leaderText}
                  </Typography>
                </Box>
              </Box> */}
            </ExpansionPanelDetails>
          </ExpansionPanel>

          <ExpansionPanel
            expanded={expanded === 'panel3'}
            onChange={handleChange('panel3')}
          >
            <ExpansionPanelSummary
              aria-controls="panel3bh-content"
              id="panel3bh-header"
            >
              <ItemIcon />
              <Typography variant="h4">
                DIE<ThinText> LEHRER</ThinText>
              </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <Box flex={1}>
                {trainers ? <StoryblokComponent content={trainers[0]} /> : null}
              </Box>
            </ExpansionPanelDetails>
          </ExpansionPanel>
        </Box>

        {/* NEWS BLOCK */}
        {news && <StoryblokComponent content={news[0]} siteInfo={siteInfo} />}
      </Box>
    </Box>
  )
}

export default StoryblokHomeblock
